module.exports = __webpack_public_path__ + "img/docker.82bc3335.svg";